import { atom } from 'jotai'
import * as R from 'remeda'

import {
  type FiveSegmentsData,
  type NineSegmentsData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { brandGroupIdAtom } from '~/atoms'
import { exists } from '~/utils'

import {
  brandIdsAtom,
  customerAttributeIdsAtom,
  dataDisplayTypeAtom,
  fiveSegmentSortValueAtom,
  nineSegmentSortValueAtom,
  questionIdsAtom,
} from './stateAtoms'

export const isTabulatableAtom = atom(
  (get) =>
    exists(get(brandGroupIdAtom)) &&
    0 < get(brandIdsAtom).length &&
    (0 < get(questionIdsAtom).length ||
      0 < get(customerAttributeIdsAtom).length),
)

export const fiveSegmentSortFunctionAtom = atom((get) => {
  const dataDisplayType = get(dataDisplayTypeAtom)
  const sortValue = get(fiveSegmentSortValueAtom)

  return <T extends FiveSegmentsData>(array: T[]) =>
    R.sortBy<T[]>((item) => {
      if (!exists(sortValue)) {
        return 0
      }

      const value =
        dataDisplayType === 'percentage'
          ? item.ratios[sortValue.columnKey]
          : item.counts[sortValue.columnKey]

      return value * (sortValue.ascending ? 1 : -1)
    })(array)
})

export const nineSegmentSortFunctionAtom = atom((get) => {
  const dataDisplayType = get(dataDisplayTypeAtom)
  const sortValue = get(nineSegmentSortValueAtom)

  return <T extends NineSegmentsData>(array: T[]) =>
    R.sortBy<T[]>((item) => {
      if (!exists(sortValue)) {
        return 0
      }

      const value =
        dataDisplayType === 'percentage'
          ? item.ratios[sortValue.columnKey]
          : item.counts[sortValue.columnKey]

      return value * (sortValue.ascending ? 1 : -1)
    })(array)
})
